import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import { IChangeLogElement } from './entity/types';
import logger from '~/utils/logger';
import toast from 'react-hot-toast';
import request from '~/utils/request';
import { IAPIResponse } from '~/utils/types';
import { StatusCodes } from 'http-status-codes';
import { useSelector } from 'react-redux';
import { State } from '~/store';

const ChangeLogModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }): React.ReactElement => {
  const organizationUuid = useSelector((state: State) => state.organization.uuid);
  const scenarioUuid = useSelector((state: State) => state.scenario.activeScenarioUuid);
  const [companyChangeLog, setCompanyChangeLog] = useState<IChangeLogElement[]>([]);

  const fetchCompanyChangeLog = async ({
    organizationUuid,
    scenarioUuid,
  }: {
    organizationUuid: string;
    scenarioUuid: string | null;
  }): Promise<void> => {
    try {
      const response = (await request({
        url: `/change-log`,
        method: 'GET',
        headers: {
          'Organization-Uuid': organizationUuid,
        },
        params: {
          scenarioUuid,
        },
      })) as IAPIResponse<IChangeLogElement[]>;

      if (response.status === StatusCodes.OK) {
        setCompanyChangeLog(response.data.data);
      } else {
        toast.error('Failed to fetch company change log');
      }
    } catch (error) {
      if (error instanceof Error) logger.error(error);
      toast.error('Failed to fetch company change log');
    }
  };

  useEffect(() => {
    if (isOpen && organizationUuid) {
      fetchCompanyChangeLog({ organizationUuid, scenarioUuid });
    }
  }, [isOpen, organizationUuid, scenarioUuid]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Change Log" showClose>
      <div>{companyChangeLog.map((changeLog) => changeLog.title)}</div>
    </Modal>
  );
};

export default ChangeLogModal;
